import { Component, OnInit } from '@angular/core';
import { AdvisorBarService } from './advisor-bar.service';

@Component({
  selector: 'app-advisor-bar',
  templateUrl: './advisor-bar.component.html',
  styleUrls: ['./advisor-bar.component.css']
})
export class AdvisorBarComponent implements OnInit {
  public advisorName: any;
  public advisorID: any;
  public advisorOrgID: any;

  public role: Number;

  constructor(private advisorBarService: AdvisorBarService) {
    advisorBarService.advisorBar$.subscribe(advisorBar => {
      this.advisorName = localStorage.getItem("selectedAdvisor") || '';
      this.advisorID = localStorage.getItem("selectedAdvisorID") || '';
      this.advisorOrgID = localStorage.getItem("selectedAdvisorOrgID") || '';
    })
  }

  ngOnInit() {
    this.advisorName = localStorage.getItem("selectedAdvisor") || '';
    this.advisorID = localStorage.getItem("selectedAdvisorID") || '';
    this.advisorOrgID = localStorage.getItem("selectedAdvisorOrgID") || '';

    this.role = Number(localStorage.getItem('roleId'));
  }
}
